import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
// import { store } from './store'
import router from './router'
import ProductZoomer from 'vue-product-zoomer'

// components
import RecallList from './components/RecallList'
import ListCards from './components/shared/list_cards'
import GridCards from './components/shared/grid_cards'
import NewsCards from './components/shared/news_cards'
import Social from './components/shared/social'

// libraries
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(ProductZoomer)
Vue.use(require('vue-moment'))

window.bus = new Vue()

// Vue.config.productionTip = false
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// custom components
Vue.component('recall-list', RecallList)
Vue.component('list-cards', ListCards)
Vue.component('grid-cards', GridCards)
Vue.component('news-cards', NewsCards)
Vue.component('social', Social)

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  created () {
    AOS.init({ disable: 'phone' })
  },
  router,
  // store,
  render: h => h(App)
})
